import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavbarService } from '../../services/navbar.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment-callback',
  imports: [TranslocoDirective, ButtonModule, CommonModule],
  templateUrl: './payment-callback.component.html',
  styleUrl: './payment-callback.component.scss'
})
export class PaymentCallbackComponent {

  screenType = ""
  message: string | undefined

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private navbar: NavbarService
  ) {
    navbar.showNavbar = false
    let r = route.snapshot.url[0].path
    let params = route.snapshot.queryParams

    if (r == "paymentCanceled") {
      this.screenType = "canceled"
      this.message = params["messaggio"]
    } else if (r == "paymentResult") {
      switch (params["esito"]) {
        case "OK":
          this.screenType = "success"
          break
        case "KO":
          this.screenType = "error"
          break
        case "ANNULLO":
          this.screenType = "canceled"
          break
        case "ERRORE":
          this.screenType = "error"
          break
        case "PEN":
          this.screenType = "pending"
          break
      }
      this.message = params["messaggio"]
    } else {
      router.navigate(["/home"])
    }
  }

  goToHome() {
    this.router.navigate(["/home"])
  }
}
